var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group_page_container"},[_c('shopping-list',{ref:"listRef",attrs:{"vpnId":_vm.vpnId,"id":"listRef"}}),_c('myFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }